import React from 'react';
import { Button, ButtonTypeMap, ExtendButtonBase } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { lightGray, white, black, gray3 } from 'utils/color-styles';

export const BackButton = (
  props: Parameters<ExtendButtonBase<ButtonTypeMap<{}, 'button'>>>[0]
): JSX.Element => (
  <Button
    {...props}
    style={{
      borderRadius: '50%',
      width: 40,
      height: 40,
      minWidth: 0,
      borderColor: lightGray,
      backgroundColor: white,
      color: black,
      ...(props.style || {}),
    }}
  >
    <ArrowBackIcon style={{ fill: gray3 }} />
  </Button>
);
